// Vendor libraries
import { createReducer, on } from '@ngrx/store';
import cloneDeep from 'lodash.clonedeep';
// NgRx actions
import { selectModule } from './selected-module.action';
import { setIncludeBenchmarkDefault } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/include-benchmark-default/include-benchmark-default.action';
import { updateModule } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/modules/modules.action';
export const selected_module = createReducer(null, on(setIncludeBenchmarkDefault, (state, action) => {
    if (state && 'include_benchmark' in state.module.customizable_fields) {
        const module = cloneDeep(state.module);
        module.customizable_fields.include_benchmark.value = action.include_benchmark_default;
        return {
            ...state,
            module,
        };
    }
    return state;
}), on(selectModule, (state, action) => {
    return action.selected_module;
}), on(updateModule, (state, action) => {
    // If the updated module is still selected, return the updated module
    if (state?.page === action.page && state.index === action.index) {
        return action;
    }
    // If the updated module isn't selected, return the currently selected module
    return state;
}));
